import * as React from 'react';

const SvgCriteriaCorp = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="24" height="24" rx="6" fill="#09264E" />
    <path
      d="M5.5 7.01758L9.6875 11.2051L17.6094 3.2832"
      stroke="#45C2CC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5 17.7988L7.3125 13.6113L3.125 17.7988"
      stroke="#F8A21B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.4062 9.45508L12.2187 13.6426L19.9375 21.3613"
      stroke="#9FA0A1"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgCriteriaCorp;
